/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/core';
import { globalTokens } from '@domain-group/fe-brary';
export var badge = function badge(colour) {
  var textColour = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalTokens.colors.white;
  return /*#__PURE__*/css("margin-right:1px;display:inline-block;padding:1px 8px;height:24px;color:", textColour, ";background-color:", colour, ";");
};